

  export const APIData = [
    {
      id: 0,
      title: "MyWeather",
      images:( process.env.PUBLIC_URL + "/assets/images/repos/myweather_ss.png"),
      alt: "weather dashboard",
      repo: "https://github.com/Kuiil7/myweather" ,
      demo:"https://my-weather-one.vercel.app/",
      description:"User can find local temperature via browser's geolocation function and, also, do query search across U.S. cities.",
      myDuty:"Sole maintainer.",
      builtWith:"Bulma, Axios, Moments, Geolocation, and https://openweathermap.org/",
      url:"https://openweathermap.org/",
      status: "Completed",
      notes:"Considering adding extra features in v2."
        },
        {
          id: 1,
          title: "MyMovies",
          images: ( process.env.PUBLIC_URL + "/assets/images/repos/mymovies_ss.png"),
          alt: "screenshot of mymovies app",
          repo: "https://github.com/Kuiil7/mymovies" ,
          demo:"https://kuiil7.github.io/mymovies/",
          description: "A website where user can search and find movies, TV shows, and actors along with trending, popularity, and other categories",
          myDuty: "Sole maintainer.",
          builtWith: "Luxon, Axios, dotenv, and Bulma and https://www.themoviedb.org/",
          url:"https://www.themoviedb.org/",
          status: "Completed",
          notes:""


        },
        {
          id: 2,
          title: "Where's My Beer?",
          images:( process.env.PUBLIC_URL +  "/assets/images/repos/wmb.png"),
          repo:"https://github.com/Kuiil7/wmb",
          alt: "screenshot of app",
          description: "Search and find microbreweries across the United States",
          myDuty:"Sole maintainer",
          builtWith: "Bulma, FontAwesome, Luxon, dotenv, and https://www.openbrewerydb.org/",
          demo: "https://kuiil7.github.io/wmb/",
          url:"https://www.openbrewerydb.org/",
          status: null,
          notes: null
          },
       
  ];

